import React from 'react';
import PropTypes from 'prop-types';
import * as search from 'searchtabular';
import PerPage from './PerPage';
import * as pluralize from "pluralize";
import { useState } from "react";
import GenModal from '../../Gen/Modal/component';
import { RenderStudentList } from '../aqueduct_table';
import ModalClose from 'app/assets/images/modal-close.svg'

const PrimaryControls = ({
  perPage, columns, rows, column, query,
  onPerPage, onSearch, onColumnChange,
  show_pagination, isCustomCoursePage, studentsCount, unknownEmails, selectedRows, toggleSelect, psaEmail,
  ...props
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Handler for "Close" button
  const handleClose = () => {
    setModalOpen(false);
  };

  // Handler for "Create Question" button
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  return (
    <div {...props}>
      {show_pagination &&
        <div className="per-page-container">
          <PerPage value={perPage} onChange={onPerPage}/>
        </div>
      }
      {isCustomCoursePage ?
        <>
          <div className="search-container">
            <search.Field
              column={column}
              query={query}
              columns={columns}
              rows={rows}
              onChange={onSearch}
              onColumnChange={onColumnChange}
              components={{
                filter: CustomField,
                props: {
                  filter: {
                    className: 'search-field',
                    placeholder: 'Search'
                  }
                }
              }}
            />
          </div>
          {studentsCount > 0 &&
            <>
              <div className="students-count">{pluralize('Student', studentsCount, true)}</div>
              <a className="students-count-mobile-view" onClick={handleModalOpen}>{pluralize('Student', studentsCount, true)}</a>

              <GenModal open={modalOpen}>
                <div className="gen-modal-panel">
                  <div className="gen-modal-header">
                    <div className="gen-modal-title">Student Added to Course</div>
                    <a onClick={handleClose} className="gen-modal-close">
                      <img src={ModalClose} alt="Close"/>
                    </a>
                  </div>
                  <div className="gen-modal-description">
                    These students were added by email but they are not yet rostered to your program. They can still be added to your course but will not have access until they have been rostered to your program and complete the registration process. 
                    <br/><br/>
                    Once they have been rostered and complete their registration, they will automatically be able to access this course.
                    <br/><br/>
                    For questions, contact {psaEmail}.
                  </div>
                  <div className="gen-modal-student-list">
                    <RenderStudentList
                      unknownEmails={unknownEmails}
                      rows={selectedRows}
                      toggleSelect={toggleSelect}
                      psaEmail={psaEmail}
                    />
                  </div>
                </div>
              </GenModal>
            </>
          }
        </>
        :
        <div className="search-container">
          <span>Search</span>
          <search.Field
            column={column}
            query={query}
            columns={columns}
            rows={rows}
            onChange={onSearch}
            onColumnChange={onColumnChange}
          />
        </div>
      }
    </div>
  );
}

const CustomField = (props, classNames) => <input className={classNames.customField || "custom-field"} {...props} />;

PrimaryControls.propTypes = {
  perPage: PropTypes.number,
  columns: PropTypes.array,
  rows: PropTypes.array,
  column: PropTypes.string,
  query: PropTypes.object,
  onPerPage: PropTypes.func,
  onSearch: PropTypes.func,
  onColumnChange: PropTypes.func,
  isCustomCoursePage: PropTypes.bool,
  studentsCount: PropTypes.number,
  unknownEmails: PropTypes.array,
  selectedRows: PropTypes.array,
  toggleSelect: PropTypes.func,
  psaEmail: PropTypes.string
};

export default PrimaryControls;
